@if (!isLoaded) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (isLoaded) {
  @if (!accounts) {
    <div fxLayout="row" fxLayoutAlign="center center">
      No Items
    </div>
  }
  <table mat-table [dataSource]="tableData" fxFill>
    <ng-container matColumnDef="accountNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
      <td mat-cell *matCellDef="let row">
        @if (row.Number) {
          {{row.Number}}
        }
        @if (!row.Number) {
          {{row.Name}}
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="budget">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Budget</th>
      <td mat-cell *matCellDef="let row">{{row.budget | currency}}</td>
    </ng-container>
    <ng-container matColumnDef="encumbrances">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Encumbrances</th>
      <td mat-cell *matCellDef="let row">{{row.encumbrances | currency}}</td>
    </ng-container>
    <ng-container matColumnDef="reserves">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Reserves</th>
      <td mat-cell *matCellDef="let row">
        @if (!row.hideReserve) {
          {{row.reserves | currency}}
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="priorYearAdjustments">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Prior Year Adj</th>
      <td mat-cell *matCellDef="let row">{{row.priorYearAdjustment | currency}}</td>
    </ng-container>
    <ng-container matColumnDef="totalActivity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Activity</th>
      <td mat-cell *matCellDef="let row">{{row.totalActivity | currency}}</td>
    </ng-container>
    <ng-container matColumnDef="budgetRemaining">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Budget Remaining</th>
      <td mat-cell *matCellDef="let row">{{row.budgetRemaining | currency}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
  </table>
}
